$('.experience_list__item').on('click', '.toggle_experience', function () {
  $(this)
    .toggleClass('opened')
    .siblings('.experience_list__item--answer')
    .slideToggle()
})
